import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { EMAIL_TEMPLATE_CONTROLLER } from "api/Service";

export const useEmailTemplates = (isOpen, patientId, consultationId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["emailTemplatesAll", tenantVal, patientId, consultationId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const params = new URLSearchParams();
      if (patientId) params.append("patientId", patientId);
      if (consultationId) params.append("consultationId", consultationId);
      const queryString = params.toString();
      const url = queryString
        ? `${tenantVal}${EMAIL_TEMPLATE_CONTROLLER}?${queryString}`
        : `${tenantVal}${EMAIL_TEMPLATE_CONTROLLER}`;
      const response = await axiosInstance.get(url);

      return response.data;
    },
    enabled: !!isOpen && !!tenantVal,
  });
};
